import request from './request';


/**
 * 查询车险信息
 */
export function getVehicleInsurance(params) {
    return request('/insurance/item', {
        method: 'GET',
        params,
    });
}

/**
 * 查询车险信息详情
 */
export function getVehicleInsuranceDetail(params) {
    return request('/insurance/detail', {
        method: 'GET',
        params,
    });
}

/**
 * 车险详情操作记录
 */
export function getVehicleInsuranceHistory(params) {
    return request('/insurance/opt-log', {
        method: 'GET',
        params,
    });
}

/**
 * 获取悦宝接口续保车险信息
 */
export function getYbRenewal(params) {
    return request('/insurance/yb-renewal', {
        method: 'GET',
        params,
    });
}

/**
 *  车险信息列表
 */
export function getInsuranceList(params) {
    return request('/insurance/list', {
        method: 'POST',
        params,
    });
}

/**
 *  编辑车险信息
 */
export function setPolicyInfo(params) {
    return request('/insurance/item/policy', {
        method: 'POST',
        params,
    });
}

/**
 *  编辑车辆信息
 */
export function setVehicleInfo(params) {
    return request('/insurance/item/vehicle-info', {
        method: 'POST',
        params,
    });
}

/**
 *  编辑关系人信息
 */
export function setApplicantInfo(params) {
    return request('/insurance/item/applicant', {
        method: 'POST',
        params,
    });
}

/**
 * 获取车险相关字段枚举值
 */
export function getInsuranceEnums() {
    return request('/insurance/column-enums', {
        method: 'GET',
    });
}

/**
 * 导出车险信息列表
 */
export function exportInsuranceList() {
    return '/insurance/list/export';
}

/**
 *  续保线索提醒列表
 */
export function getRenewalCludesList(params) {
    return request('/insurance/renewal-clues', {
        method: 'POST',
        params,
    });
}

/**
 * 导出续保线索提醒列表
 */
export function exportRenewalCludesList() {
    return '/insurance/renewal-clues/export';
}

/**
 * 续保线索提醒详情
 */
export function getRenewalCludesDetail(params) {
    return request('/insurance/renewal-clues/item', {
        method: 'GET',
        params,
    });
}
/**
 * 续保线索责任人选择列表
 */
export function getRenewalAssignees(params) {
    return request('/insurance/renewal-clues/assignees', {
        method: 'GET',
        params,
    });
}

/**
 *  续保线索提醒处理
 */
export function handleRenewalCludes(params) {
    return request('/insurance/renewal-clues/handle', {
        method: 'POST',
        params,
    });
}

/**
 *  续保线索批量分配
 */
export function handleRenewalAllocBatch(params) {
    return request('/insurance/renewal-clues/alloc-batch', {
        method: 'POST',
        params,
    });
}

/**
 *  续保线索分配
 */
export function handleRenewalAlloc(params) {
    return request('/insurance/renewal-clues/alloc', {
        method: 'POST',
        params,
    });
}

/**
 *  领取续保线索
 */
export function handleRenewalReceive(params) {
    return request('/insurance/renewal-clues/receive', {
        method: 'POST',
        params,
    });
}

/**
 * 续保线索提醒详情操作记录
 */
export function getRenewalCludesHistory(params) {
    return request('/insurance/renewal-clues/opt-log', {
        method: 'GET',
        params,
    });
}

/**
 * 续保线索提醒数据统计
 */
export function getRenewalCludesNumber() {
    return request('/insurance/renewal-clues/stat', {
        method: 'GET',
    });
}

/**
 * 车险服务状态
 */
export function getInsuranceServiceStatus() {
    return request('/insurance-service/status', {
        method: 'GET',
    });
}

/**
 * 获取保司险别配置
 */
export function getCompanyRiskConfig(params) {
    return request('/insurance/company-risk-config', {
        method: 'GET',
        params,
    });
}

/**
 * 获取保司列表
 */
export function getCompanyList() {
    return request('/insurance/company-list', {
        method: 'GET',
    });
}

/**
 * 保费计算
 * @params:
 * params 保费计算所需参数
 * fullRes true表示返回值header为200时，返回data所有数据（默认false，通过data中code判断是否报错）
 */
export function setInsuranceQuote(params, fullRes) {
    return request('/insurance/quote', {
        method: 'POST',
        params,
        fullRes,
    });
}

/**
 * 核保下单
 */
export function setInsuranceOrder(params, fullRes) {
    return request('/insurance/order', {
        method: 'POST',
        params,
        fullRes,
    });
}

/**
 * 支付申请
 */
export function setInsurancePayment(params, fullRes) {
    return request('/insurance/payment', {
        method: 'POST',
        params,
        fullRes,
    });
}

/**
 * 影像上传
 */
export function setInsuranceUpload(params) {
    return request('/insurance/upload-image', {
        method: 'POST',
        params,
    });
}

/**
 * 获取默认保司险别配置
 */
export function getCompanyRiskDefault() {
    return request('/insurance/company-risk-config-default', {
        method: 'GET',
    });
}
